export function selected_group_active (state) {
  return state.course_groups ? state.course_groups.find(c => c.is_selected) : {}
}
export function showCategory (state) {
  return state.showCategory
}
